import {
  blurState,
  tutorialState,
  uiState
} from '@/stores'
import {
  BlueBoxTextType,
  SectionNames
} from '../../types'
import { tutorialDefaultStates } from './TutorialDefaultState'
import {
  MobileDetector,
  requestManager,
  tutorialManager,
  TutorialMessageColors
} from '@powerplay/core-minigames'
import {
  gameSettingsState,
  loadingState,
  tutorialCoreState
} from '@powerplay/core-minigames-ui-ssm'

/**
 * Informacie pre UI priapdne kontrolne prvky na zmenu UI roznych taskov
 */
export class TutorialUIChange {

  /** Meno prave beziacej sekcie */
  private actualSectionName: SectionNames | undefined

  /** Hack lebo nulty task nespusta intro */
  private blurActive = false

  /** Samotny stav ktory chceme vo roznych krokoch tutorialu */
  private uiState = {
    [SectionNames.mobileSidePick]: () => {

      console.log('SECTION FIRST')
      if (!this.blurActive) {

        blurState().isActive = true
        this.blurActive = true

      }
      this.setMobile(true)
      this.hideLoading()

    },
    [SectionNames.introductionNewInstructor]: () => {

      this.resetTypeWrite()
      this.setMobile(false)
      this.setMessage(true, `tutorialFirstPick${requestManager.disciplineID}`)
      this.setAnne(true, false, 'stefecekova')
      this.hideLoading()

    },
    [SectionNames.startSection]: () => {

      this.resetTypeWrite()
      this.setMobile(false)
      this.setMessage(true, `tutorialText${requestManager.disciplineID}-1`)
      this.setAnne(true, false)
      this.hideLoading()

    },
    [SectionNames.startSectionSecond]: () => {

      this.resetTypeWrite()
      this.setMessage(true, `tutorialText${requestManager.disciplineID}-2`, undefined, undefined, true)
      this.setAnne(true, false)

      tutorialState().showBarStart = true
      uiState().blueBoxTextType = BlueBoxTextType.run

    },
    [SectionNames.startSectionThird]: () => {

      tutorialState().showBarStart = false
      this.resetTypeWrite()
      this.setMessage(false, '')
      this.setAnne(false)

    },
    [SectionNames.startSectionFourth]: () => {

      this.resetTypeWrite()
      this.setMessage(false, '')
      this.setAnne(false)

    },
    [SectionNames.startSectionFifth]: () => {

      this.resetTypeWrite()
      this.setMessage(false, '')
      this.setAnne(false)

    },
    [SectionNames.startSectionSixth]: () => {

      this.resetTypeWrite()
      this.setMessage(false, '')
      this.setAnne(false)

    },
    [SectionNames.startSectionSeventh]: () => {

      this.resetTypeWrite()
      this.setMessage(false, '')
      this.setAnne(false)

    },
    [SectionNames.startSectionEight]: () => {

      this.resetTypeWrite()
      this.setMessage(false, '')
      this.setAnne(false)

    },
  }

  /**
   * Schovanie loadingu
   */
  private hideLoading(): void {

    // dame prec loading
    loadingState().showLoading = false

  }

  /** Referencia na vue */
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  private vm: any

  /**
   * Nastavenie Vue referencie
   * @param vm - vue referencia
   */
  public registerVM(vm: unknown): void {

    this.vm = vm

  }

  /**
   * Zena UI podla aktualnej sekcie
   * @param sectionName - Meno aktualnej sekcie
   */
  private changeUi(sectionName: SectionNames): void {

    this.uiState[sectionName]()

  }

  /**
   * Resetnutie typewrite
   */
  private resetTypeWrite(): void {

    tutorialManager.setTypeWriting(true)
    tutorialCoreState().typeWriter = true

  }

  /**
   * Inicializovanie
   */
  public init(): void {

    // Ak bude treba.

  }

  /**
   * Hlavna logika ui zmeny
   */
  private tutorialUILogic(): void {

    const sectionName = tutorialManager.getActualSectionName() as SectionNames
    if (sectionName && sectionName !== this.actualSectionName) {

      this.changeUi(sectionName)
      this.actualSectionName = sectionName

    }

  }

  /**
   * Public metoda do game loopu
   */
  public update(): void {

    tutorialDefaultStates.update()
    this.tutorialUILogic()

  }

  /**
   * Nastavenie Anny
   * @param showAnne - Ci sa ma zobrazit
   * @param isLeft - Ci sa ma umiestnit vpravo
   * @param instructorName - Meno instruktora
   * @returns this
   */
  public setAnne(
    showAnne: boolean,
    isLeft = gameSettingsState().isLeft,
    instructorName = 'volko2'
  ): this {

    tutorialState().anne = {
      showAnne,
      isRight: isLeft,
      instructorName,
      instructorNameText: instructorName === 'volko2' ? 'utTutorialVolko' : 'utTutorialStefecekova'
    }

    return this

  }

  /**
   * Nastavenie hlasky pre tutorial
   * @param showMessage - ci sa ma zobrazit hlaska
   * @param message - text
   * @param color - farba
   * @param yellowTextSpecial - specialny text klikni na XYZ
   * @returns this
   */
  public setMessage(
    showMessage: boolean,
    message = '',
    color = TutorialMessageColors.blank,
    yellowTextSpecial = '',
    offset = false
  ): this {

    let yellowText = this.vm.$i18n.t('clickToContinueTemp')
    if (MobileDetector.isMobile()) yellowText = this.vm.$i18n.t('tapToContinue')
    if (yellowTextSpecial) {

      yellowText = this.vm.$i18n.t('tapToButton').replace(
        '[BUTTON]',
        this.vm.$i18n.t(yellowTextSpecial)
      )

    }

    tutorialState().tutorialMessage = {
      showMessage,
      message,
      color,
      yellowText,
      offset,
      yellowTextSpecial: yellowTextSpecial !== ''
    }

    return this

  }

  /**
   * Nastavenie mobilnej uvodnej obrazovky
   * @param show - Ci ma byt zobrazena
   * @returns this
   */
  public setMobile(show: boolean): this {

    tutorialState().mobile = show
    return this

  }

}

export const tutorialUIChange = new TutorialUIChange()
